import { useMutation } from "@apollo/client";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import OdooProductSelector from "components/shared/OdooProductSelector";
import { SAVE_PRODUCT } from "pages/manage/products/All/graphql";

const LinkOdooProductView = ({ instance, product, hide }) => {
  const [saveProduct, saveProductRes] = useMutation(SAVE_PRODUCT, {
    onCompleted() {
      Alert("success", "Product linked successfully");
      hide();
    },
    onError(error) {
      Alert("error", error.message);
    },
  });

  function linkProductHandler(product, odooProductId) {
    saveProduct({
      variables: {
        id: product.id,
        simpleFields: { odooIdInc: odooProductId },
      },
    });
  }

  if (saveProductRes.loading) return <Spinner />;

  return (
    <OdooProductSelector
      instance={instance}
      initialSearchText={product.number}
      onSelect={(odooProductId) => linkProductHandler(product, odooProductId)}
    />
  );
};

export default LinkOdooProductView;
